import React from "react";
import Window from "./Window";
import Common from "../Common";
import CheckFairness from "./CheckFairness";

import "./MyBetsHistory.css";
import { Controller } from "../core/Controller";
import { Comm } from "../core/comm/Comm";

export default class MyBetsHistory extends React.Component<MyBetsHistory.Props, MyBetsHistory.State>
{

    constructor(props: MyBetsHistory.Props)
    {
        super(props);
    }


    render()
    {
        return (
            <Window
                id="betHistory"
                title={window.lang.shared.my_bet_history}
            >

                <Wrapper />

            </Window>
        )
    }


}


class Wrapper extends React.Component<MyBetsHistory.Props, MyBetsHistory.State>
{


    constructor(props: any)
    {
        super(props);

        this.state = {
            data: null,
            loading: false,
            gameRoundId: Number(Controller.gameRoundId)
        };
    }


    componentDidMount()
    {
        Comm.on(Comm.RESPONSE.MY_BETS, this.onBetsResponse, this);
        Comm.on(Comm.RESPONSE.GAME_STATE_STARTING, this.onNewGameRound, this);
        Comm.send(Comm.REQUEST.MY_BETS, {});
    }


    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.MY_BETS, this.onBetsResponse, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_STARTING, this.onNewGameRound, this);
    }


    onNewGameRound()
    {
        this.setState({
            gameRoundId: Number(Controller.gameRoundId)
        });
    }


    onBetsResponse(data: Comm.ResponseTypes.MyBets)
    {
        if (!this.state.data)
        {
            this.setState({
                data: data.bets,
                loading: false
            });
        }
        else
        {
            this.setState({
                data: this.state.data.concat(data.bets),
                loading: false
            });
        }
    }


    checkFairness(id: string)
    {
        app.addWindow(<CheckFairness
            roundId={id}
        />);
    }


    clickShare(data: Comm.ResponseTypes.BetData)
    {
        notifications.message(lang.shared["ui-components"].toastr["toastr-message"]["copied-for-chat"]);
        copyToClipboard("/share_bet:" + data.bet_id + " ");
        Controller.setBetCopy(data);
    }


    clickLoadMore()
    {
        if (this.state.loading || !this.state.data)
        {
            return;
        }

        Comm.send(Comm.REQUEST.MY_BETS, {
            last_bet_id: this.state.data[this.state.data.length - 1].bet_id
        });

        this.setState({
            loading: true,
        });

    }


    render()
    {
        const lang = window.lang.game["bets-widget"];
        const lShared = window.lang.shared;
        
        return (<>
            <div className="list_header">
                <div className="cell1">
                    {lang.date}
                </div>
                <div className="cell2 bet-mult-win">
                    <div className="bet">
                        {lShared.bet}, {currency}
                    </div>
                    <div className="mult">
                        X
                    </div>
                    <div className="win">
                        {lShared.cash_out}, {currency}
                    </div>
                </div>
                <div className="cell3">
                    
                </div>
            </div>

            <div className="list">
                {this.renderList()}
            </div>

            {this.renderLoading()}

            <div
                className="loadMore"
                onClick={this.clickLoadMore.bind(this)}
            >
                {lShared.load_more}
            </div>

        </>);
    }


    renderLoading()
    {
        if (this.state.loading)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        return null;
    }


    renderList()
    {
        if (!this.state.data)
        {
            return (
                <div className="loader">

                </div>
            );
        }

        const arr: Array<JSX.Element> = [];

        this.state.data.forEach((data, index) =>
        {
            const disabled = data.game_round_id.toString() == Controller.gameRoundId;

            // console.log("myBetsHistory, " + data.bet_amount + " vs " + data.win_amount + " win? " + (Number(data.win_amount) > Number(data.bet_amount)));

            let className = "";
            if (!data.win_amount || Number(data.win_amount) == 0)
            {
                className = "lost"
            }
            else if ((Number(data.win_amount) >= Number(data.bet_amount)))
            {
                className = "win";
            }

            arr.push(
                <div
                    className={"item " + className}
                    key={"my_bet_" + index}
                >
                    <div className="date">
                        <div>
                            {Common.parseDate(data.timestamp, "time", true)}
                        </div>
                        <div>
                            {Common.parseDate(data.timestamp, "date_small", true)}
                        </div>
                    </div>
                    <div className="bet-mult-win">
                        <div className="bet">
                            {Common.renderCurrency(data.bet_amount, data.currency)}
                        </div>
                        <div className="mult">
                            {Common.renderMultiplier(Number(data.multiplier) || data.crashpoint)}
                        </div>
                        <div className="win">
                            {Common.renderCurrency(data.win_amount, data.currency, "")}
                        </div>
                    </div>

                    <div className="buttons">

                        <div
                            className={"icon_fair " + (disabled ? "disabled" : "")}
                            onClick={this.checkFairness.bind(this, data.game_round_id.toString())}
                        >
                            
                        </div>

                        <div
                            className="icon_share"
                            onClick={this.clickShare.bind(this, data)}
                        >
                            
                        </div>

                    </div>
                </div>
            );
        });

        return arr;
    }


}


export namespace MyBetsHistory
{


    export interface Props
    {

    }


    export interface State
    {
        data: Array<Comm.ResponseTypes.BetData>;
        loading: boolean;
        gameRoundId: number;
    }


}